var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.154,
    height: 12.031,
    viewBox: "0 0 14.154 12.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3629",
    "data-name": "Path 3629",
    d: "M607.52,400.82a2.755,2.755,0,0,0,4.312-2.3,2.837,2.837,0,0,0-.476-1.568l-.753.759a1.745,1.745,0,0,1-1.525,2.548,1.7,1.7,0,0,1-.8-.2Zm6.105-6.158a10.5,10.5,0,0,1,2.486,3.651.524.524,0,0,1,0,.411c-1.478,3.468-4.1,5.547-7.037,5.547h-.007a6.407,6.407,0,0,1-3.736-1.241l-1.34,1.352a.509.509,0,0,1-.366.154.5.5,0,0,1-.366-.154.521.521,0,0,1-.062-.655l.021-.028,10.214-10.306a.191.191,0,0,0,.034-.042h0a.2.2,0,0,0,.035-.042l.649-.655a.52.52,0,0,1,.732.739Zm-7.308,3.861a3.283,3.283,0,0,0,.049.529l-2.556,2.578a11.2,11.2,0,0,1-1.769-2.9.524.524,0,0,1,0-.411c1.478-3.468,4.1-5.54,7.03-5.54h.006a6.263,6.263,0,0,1,2.831.683l-2.307,2.327a3.217,3.217,0,0,0-.525-.049,2.774,2.774,0,0,0-2.76,2.788Z",
    transform: "translate(-601.999 -392.504)",
    fill: "#2b2728",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.3e81e1d0e4ec9f3b616d4fe8b85bf45e.svg";
export { ForwardRef as ReactComponent };